var initializeBlockAccordion = function(block){
    
    jQuery(".accordion h3", block).click(function(){
		
		var currentRow = jQuery(this).parent();
			
		currentRow.toggleClass('active');
		jQuery('.content', currentRow).slideToggle(300);
		
	});
	
	if (typeof getUrlVars === "function") {
	
		var urlRow = getUrlVars()['row'];
				
		if(urlRow) {
			
			jQuery(".accordion .row:eq(" + urlRow + ") h3", block).trigger('click');
			
			jQuery('html, body').animate({scrollTop: jQuery(".accordion .row:eq(" + urlRow + ")", block).offset().top - 10}, 'slow');
			
		} 
		
	}
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-accordion').each(function(){
        initializeBlockAccordion(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=accordion', initializeBlockAccordion);
